import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./treatmentPlanPopup.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import { useEffect, useState } from "react";
import { useGetAppointmentsProgramsByTherapistsIdMutation } from "../../../services/api/utils.api";
import { useAppSelector } from "../../../services/hooks";
import { adminSelector } from "../../../services/selectors/user.selectors";
import { IUserReport } from "../../../services/types/users.types";
import {
  appointmentsProgramsDataSelector,
  userAppointmentsProgramsSelector,
} from "../../../services/selectors/utils.selectors";
import Loader from "../../loader/loader";
import Tooltip from "../../tooltip/tooltip";
import Modal from "../modal/Modal";
import ProgramDatesPopup from "../programDatesPopup/programDatesPopup";
import { TAppointmentsProgramsData } from "../../../services/types/utils.types";
import ActionButtonTooltip from "../../ActionButtonTooltip/actionButtonTooltip";
function TreatmentPlanPopup({
  onClose,
  user,
}: IPopupWithoutProps & { user: IUserReport }) {
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [programToEdit, setProgramToEdit] = useState<
    TAppointmentsProgramsData | undefined
  >(undefined);

  const admin = useAppSelector(adminSelector);
  const appointmentsProgramsData = useAppSelector(
    appointmentsProgramsDataSelector
  );
  const userAppointmentsPrograms = useAppSelector(
    userAppointmentsProgramsSelector
  );

  const [getAppointmentsPrograms, { isLoading }] =
    useGetAppointmentsProgramsByTherapistsIdMutation();

  useEffect(() => {
    if (admin && user.Users.Guid) {
      getAppointmentsPrograms({
        companyId: admin.companyId,
        therapistsGuid: user.Users.Guid,
      });
    }
  }, [admin, getAppointmentsPrograms, user]);

  return (
    <article className={popupStyles.popup}>
      <>
        <h2 className={popupStyles.popup__title}>
          {t('TREATMENT_PLANS_FOR')}{user.Users.FirstName} {user.Users.LastName}{" "}
        </h2>

        <ul className={`list ${popupStyles.list}`}>
          {Array.isArray(userAppointmentsPrograms) && userAppointmentsPrograms.length !== 0 ? (
            <>
              <li
                className={`${popupStyles.listRow} ${popupStyles.listRow_header}`}
              > 
                {/* <p className={questionnaireStyles.listCell}>מספר</p> */}
                <p className={`listCell`}>{t('PLAN_NAME:')}</p>
                <p className={`listCell`}>{t('PATIENT_NAME:')}</p>
                {/* <p className={questionnaireStyles.listCell}>{t('SESSION_DURATION')}</p> */}
                {/* <p className={questionnaireStyles.listCell}>{t('COLUMN_FREQUENCY')}</p> */}
                {/* <p className={questionnaireStyles.listCell}>{t('SUPPORT_ROLE')}</p> */}
                <p className={`listCell`}>{t('COLUMN_STATUS')}</p>
                {/* <p className={questionnaireStyles.listCell}>{t('CREATED_BY')}</p> */}
                {/* <p className={questionnaireStyles.listCell}>{t('THERAPIST_NAME')}</p> */}
                <p className={`listCell`}>{t('COLUMN_OPTIONS')}</p>
              </li>
              {userAppointmentsPrograms.map((p, index) => (
                <li
                  key={p.appointmentsProgram?.id}
                  className={`${popupStyles.listRow} ${
                    index % 2 === 0 && popupStyles.listRow_colored
                  }`}
                >
                  {/* <p className={questionnaireStyles.listCell}>
                    {p.appointmentsProgram?.id}
                  </p> */}
                  <p className={`listCell`}>{p.appointmentsProgram.name}</p>
                  <p className={`listCell`}>{p.user?.fullName}</p>
                  {/* <p className={questionnaireStyles.listCell}>
                    {appointmentsProgramsData.AppointmentsDurations.find(
                      (a) =>
                        a.Id ===
                        p.appointmentsProgram.appointmentsDurationsId
                    )?.Minutes || "-"}
                  </p> */}
                  {/* <p className={questionnaireStyles.listCell}>
                    {appointmentsProgramsData.AppointmentsSequence.find(
                      (a) =>
                        a.Id ===
                        p.appointmentsProgram.appointmentsSequenceId
                    )?.label || "-"}
                  </p> */}
                  {/* <p className={questionnaireStyles.listCell}>
                    {appointmentsProgramsData.Roles.find(
                      (r) => r.Id === p.appointmentsProgram.roleId
                    )?.label || p.appointmentsProgram.roleId}
                  </p> */}
                  <p className={`listCell`}>
                    {appointmentsProgramsData.AppointmentsProgramsStatus.find(
                      (s) => s.Id === p.appointmentsProgram.statusId
                    )?.label || p.appointmentsProgram.statusId}
                  </p>
                  {/* <p className={questionnaireStyles.listCell}>
                    {p.createUserName || noDataLabel}
                  </p>
                  <p className={questionnaireStyles.listCell}>
                    {p.therapistUserName || "-"}
                  </p> */}
                  <ActionButtonTooltip
                   className={`btn btn_type_schedule`}
                   onClick={() => {
                      setShowScheduleModal(true);
                      setProgramToEdit(p);
                    }}
                  text={t('VIEW_PLAN_DATES')}
                  />
                </li>
              ))}
            </>
          ) : isLoading ? (
            <Loader />
          ) : (
            <h3>{t('NO_ACTIVE_TREATMENT_PLANS')}</h3>
          )}
        </ul>
      </>
      {showScheduleModal && programToEdit && (
        <Modal
          wide={true}
          onClose={() => {
            setShowScheduleModal(false);
            setProgramToEdit(undefined);
          }}
        >
          <ProgramDatesPopup treatmentPlan={programToEdit} />
        </Modal>
      )}
    </article>
  );
}

export default TreatmentPlanPopup;
